import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnimationsModule } from '../animations/animations.module';
import { ColorModule } from '../color/color.module';

import { AlertComponent } from './alert.component';
export class AlertModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, AnimationsModule, ColorModule],
    exports: [AlertComponent],
    declarations: [AlertComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AlertModule_tsickle_Closure_declarations() {
/** @type {?} */
AlertModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AlertModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
